import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  slideContainer: {
    paddingBottom: theme.spacing(4),
  },
}));

export default useStyles;
